// src/enums.ts
var UserRole = {
  CUSTOMER: "CUSTOMER",
  MERCHANT_OWNER: "MERCHANT_OWNER",
  MERCHANT_STAFF: "MERCHANT_STAFF",
  COURIER: "COURIER",
  ADMIN: "ADMIN"
};
var UserStatus = {
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  PENDING_VERIFICATION: "PENDING_VERIFICATION"
};
var MerchantStatus = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  CLOSED: "CLOSED"
};
var BillingPlan = {
  /** Un porcentaje de cada venta, con la tasa que tenga el comercio. */
  COMMISSION: "COMMISSION",
  /** Cuota fija mensual; los pedidos no pagan comisión. */
  MONTHLY: "MONTHLY"
};
var BILLING_PLAN_LABELS = {
  [BillingPlan.COMMISSION]: "Comisi\xF3n por pedido",
  [BillingPlan.MONTHLY]: "Mensualidad fija"
};
var MerchantUserRole = {
  OWNER: "OWNER",
  STAFF: "STAFF"
};
var OrderStatus = {
  PENDING_PAYMENT: "PENDING_PAYMENT",
  /**
   * Pedido para una fecha futura, todavía sin despachar.
   *
   * Solo lo usan las encomiendas programadas: esperan a que administración
   * las apruebe y a que llegue su hora. No ocupan domiciliario ni entran al
   * monitor de operación, porque no hay nada que vigilar hasta que salgan.
   */
  SCHEDULED: "SCHEDULED",
  PLACED: "PLACED",
  ACCEPTED: "ACCEPTED",
  PREPARING: "PREPARING",
  READY_FOR_PICKUP: "READY_FOR_PICKUP",
  PICKED_UP: "PICKED_UP",
  ON_THE_WAY: "ON_THE_WAY",
  DELIVERED: "DELIVERED",
  CANCELLED: "CANCELLED",
  REJECTED: "REJECTED"
};
var PaymentMethod = {
  /** Contraentrega: el domiciliario cobra al entregar. */
  CASH: "CASH",
  /**
   * Transferencia a la cuenta del domiciliario.
   *
   * El cliente transfiere y sube el comprobante; el domiciliario lo verifica
   * en su banco antes de soltar el pedido. No hay pasarela de por medio: el
   * domiciliario sigue siendo quien recauda, solo cambia el medio.
   */
  TRANSFER: "TRANSFER",
  /**
   * A cuenta del comercio: no se cobra nada en la puerta.
   *
   * Solo para los domiciliarios que pide un comercio para sus propios envíos.
   * El importe se acumula y se le descuenta en el cierre del período, junto
   * con sus comisiones; el domiciliario no recauda y así se lo dice su app.
   *
   * Queda fuera de `ACTIVE_PAYMENT_METHODS` a propósito: un cliente no puede
   * elegirlo, y el servidor lo pone por su cuenta según quién pide el envío.
   */
  ACCOUNT: "ACCOUNT",
  /** Reservados para cuando se conecte una pasarela; hoy no se aceptan. */
  CARD: "CARD",
  PSE: "PSE",
  NEQUI: "NEQUI",
  WALLET: "WALLET"
};
var PAYMENT_METHOD_LABELS = {
  [PaymentMethod.CASH]: "Efectivo",
  [PaymentMethod.TRANSFER]: "Transferencia",
  [PaymentMethod.ACCOUNT]: "A cuenta del comercio",
  [PaymentMethod.CARD]: "Tarjeta",
  [PaymentMethod.PSE]: "PSE",
  [PaymentMethod.NEQUI]: "Nequi",
  [PaymentMethod.WALLET]: "Billetera"
};
var ACTIVE_PAYMENT_METHODS = [
  PaymentMethod.CASH,
  PaymentMethod.TRANSFER
];
var ReceiptStatus = {
  /** Subido por el cliente, esperando que el domiciliario lo verifique. */
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var AccountType = {
  NEQUI: "NEQUI",
  DAVIPLATA: "DAVIPLATA",
  BANCOLOMBIA: "BANCOLOMBIA",
  OTRO_BANCO: "OTRO_BANCO"
};
var BankAccountKind = {
  AHORROS: "AHORROS",
  CORRIENTE: "CORRIENTE"
};
var PaymentStatus = {
  PENDING: "PENDING",
  AUTHORIZED: "AUTHORIZED",
  PAID: "PAID",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  PARTIALLY_REFUNDED: "PARTIALLY_REFUNDED"
};
var CourierStatus = {
  OFFLINE: "OFFLINE",
  AVAILABLE: "AVAILABLE",
  BUSY: "BUSY",
  ON_BREAK: "ON_BREAK"
};
var VehicleType = {
  MOTORCYCLE: "MOTORCYCLE",
  BICYCLE: "BICYCLE",
  CAR: "CAR",
  WALKING: "WALKING"
};
var VEHICLE_LABELS = {
  [VehicleType.MOTORCYCLE]: "Moto",
  [VehicleType.BICYCLE]: "Bicicleta",
  [VehicleType.CAR]: "Carro",
  [VehicleType.WALKING]: "A pie"
};
var ACCOUNT_TYPE_LABELS = {
  [AccountType.NEQUI]: "Nequi",
  [AccountType.DAVIPLATA]: "Daviplata",
  [AccountType.BANCOLOMBIA]: "Bancolombia",
  [AccountType.OTRO_BANCO]: "Otro banco"
};
var ACCOUNT_KIND_LABELS = {
  [BankAccountKind.AHORROS]: "Ahorros",
  [BankAccountKind.CORRIENTE]: "Corriente"
};
function esBilletera(tipo) {
  return tipo === AccountType.NEQUI || tipo === AccountType.DAVIPLATA;
}
var AssignmentStatus = {
  OFFERED: "OFFERED",
  ACCEPTED: "ACCEPTED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
  /** El domiciliario lo tenía y lo soltó, con motivo escrito. */
  RELEASED: "RELEASED"
};
var DiscountType = {
  PERCENTAGE: "PERCENTAGE",
  FIXED_AMOUNT: "FIXED_AMOUNT",
  FREE_DELIVERY: "FREE_DELIVERY"
};
var SettlementStatus = {
  PENDING: "PENDING",
  PAID: "PAID",
  /** Se pasó la fecha límite sin pagar. */
  OVERDUE: "OVERDUE",
  CANCELLED: "CANCELLED"
};
var Portal = {
  SHOP: "SHOP",
  // kick.test — clientes
  PANEL: "PANEL",
  // comercios.kick.test — comercios y admin
  COURIER_APP: "COURIER_APP"
  // app móvil — domiciliarios
};
var PORTAL_ROLES = {
  [Portal.SHOP]: [UserRole.CUSTOMER],
  [Portal.PANEL]: [UserRole.MERCHANT_OWNER, UserRole.MERCHANT_STAFF, UserRole.ADMIN],
  [Portal.COURIER_APP]: [UserRole.COURIER]
};
function canLoginToPortal(role, portal) {
  return PORTAL_ROLES[portal].includes(role);
}
var NotificationType = {
  // Al cliente
  ORDER_ACCEPTED: "ORDER_ACCEPTED",
  ORDER_REJECTED: "ORDER_REJECTED",
  COURIER_ASSIGNED: "COURIER_ASSIGNED",
  ORDER_ON_THE_WAY: "ORDER_ON_THE_WAY",
  ORDER_DELIVERED: "ORDER_DELIVERED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  PAYMENT_APPROVED: "PAYMENT_APPROVED",
  PAYMENT_REJECTED: "PAYMENT_REJECTED",
  /** Un mensaje en el chat del pedido. */
  ORDER_MESSAGE: "ORDER_MESSAGE",
  /** Un mensaje del chat de soporte. */
  SUPPORT_MESSAGE: "SUPPORT_MESSAGE",
  RATING_REQUEST: "RATING_REQUEST",
  MERCHANT_REPLY: "MERCHANT_REPLY",
  /** Su encomienda programada quedó confirmada por administración. */
  PARCEL_APPROVED: "PARCEL_APPROVED",
  /**
   * La tarifa cambió y hace falta que confirme antes de despacharla.
   *
   * Va aparte de los avisos de estado porque **pide una acción**: sin
   * respuesta la encomienda no sale, y eso merece sonar distinto.
   */
  PARCEL_REPRICED: "PARCEL_REPRICED",
  /** Cuenta del comercio: plan, vencimiento, pago o suspensión. */
  MERCHANT_BILLING: "MERCHANT_BILLING",
  // A administración
  /** Hay una encomienda programada esperando decisión. */
  PARCEL_PENDING_APPROVAL: "PARCEL_PENDING_APPROVAL",
  /** Un lote de envíos o un pedido a comercio no aliado espera asignación manual. */
  MANUAL_ASSIGNMENT_PENDING: "MANUAL_ASSIGNMENT_PENDING",
  // Pedido por lista
  /** Al cliente: su lista quedó cotizada y debe confirmar el total. */
  LIST_QUOTED: "LIST_QUOTED",
  /** Al comercio: el cliente confirmó la lista; a aceptar y preparar. */
  LIST_APPROVED: "LIST_APPROVED",
  /** Una lista lleva demasiado sin revisarse: repique al comercio y aviso a administración. */
  LIST_REVIEW_SLOW: "LIST_REVIEW_SLOW",
  // Al comercio
  ORDER_PLACED: "ORDER_PLACED",
  ORDER_PICKED_UP: "ORDER_PICKED_UP",
  NO_COURIER: "NO_COURIER",
  NEW_RATING: "NEW_RATING",
  // Saldo prepago del domiciliario
  /** Una recarga espera revisión de administración. */
  RECHARGE_PENDING: "RECHARGE_PENDING",
  RECHARGE_APPROVED: "RECHARGE_APPROVED",
  RECHARGE_REJECTED: "RECHARGE_REJECTED",
  /** El saldo llegó a cero: no puede seguir en turno hasta recargar. */
  BALANCE_EMPTY: "BALANCE_EMPTY",
  // Al domiciliario
  /** Mensaje de administración a todos los domiciliarios («conéctate, hay pedidos»). */
  ADMIN_BROADCAST: "ADMIN_BROADCAST",
  /** A administración y al comercio: un domiciliario soltó el pedido, con su motivo. */
  COURIER_RELEASED: "COURIER_RELEASED",
  /** A los domiciliarios en turno: hay un pedido en la lista de pendientes. */
  PENDING_ORDER_AVAILABLE: "PENDING_ORDER_AVAILABLE",
  ASSIGNMENT_OFFERED: "ASSIGNMENT_OFFERED",
  RECEIPT_UPLOADED: "RECEIPT_UPLOADED",
  ORDER_TAKEN_AWAY: "ORDER_TAKEN_AWAY"
};
var ComplaintReason = {
  MISSING_ITEM: "MISSING_ITEM",
  WRONG_ITEM: "WRONG_ITEM",
  QUALITY: "QUALITY",
  LATE: "LATE",
  NEVER_ARRIVED: "NEVER_ARRIVED",
  COURIER_BEHAVIOR: "COURIER_BEHAVIOR",
  CHARGE: "CHARGE",
  OTHER: "OTHER"
};
var COMPLAINT_REASON_LABELS = {
  [ComplaintReason.MISSING_ITEM]: "Falt\xF3 un producto",
  [ComplaintReason.WRONG_ITEM]: "Lleg\xF3 algo que no ped\xED",
  [ComplaintReason.QUALITY]: "La comida lleg\xF3 en mal estado",
  [ComplaintReason.LATE]: "Se demor\xF3 demasiado",
  [ComplaintReason.NEVER_ARRIVED]: "Nunca lleg\xF3",
  [ComplaintReason.COURIER_BEHAVIOR]: "Problema con el domiciliario",
  [ComplaintReason.CHARGE]: "Me cobraron mal",
  [ComplaintReason.OTHER]: "Otra cosa"
};
var ComplaintStatus = {
  OPEN: "OPEN",
  IN_REVIEW: "IN_REVIEW",
  RESOLVED: "RESOLVED",
  REJECTED: "REJECTED"
};
var COMPLAINT_STATUS_LABELS = {
  [ComplaintStatus.OPEN]: "Abierto",
  [ComplaintStatus.IN_REVIEW]: "En revisi\xF3n",
  [ComplaintStatus.RESOLVED]: "Resuelto",
  [ComplaintStatus.REJECTED]: "Sin lugar"
};
var StoryMedia = {
  IMAGE: "IMAGE",
  /** GIF: se sirve tal cual, sin convertir, o deja de moverse. */
  ANIMATED: "ANIMATED",
  VIDEO: "VIDEO"
};
var SupportStatus = {
  /** El cliente escribió lo último: espera respuesta. */
  PENDING: "PENDING",
  /** Respondió soporte. */
  ANSWERED: "ANSWERED"
};
var OrderType = {
  /** De un comercio al cliente. */
  DELIVERY: "DELIVERY",
  /** De un punto a otro, sin comercio de por medio. */
  PARCEL: "PARCEL"
};
var ParcelSize = {
  /** Sobres, documentos, llaves. */
  DOCUMENT: "DOCUMENT",
  /** Una caja de zapatos, un mercado pequeño. */
  MEDIUM: "MEDIUM",
  /** No entra en un baúl de moto. */
  LARGE: "LARGE"
};
var PARCEL_SIZE_LABELS = {
  [ParcelSize.DOCUMENT]: "Sobre o documento",
  [ParcelSize.MEDIUM]: "Caja mediana",
  [ParcelSize.LARGE]: "Voluminoso"
};
var PARCEL_SIZE_HINTS = {
  [ParcelSize.DOCUMENT]: "Cabe en un bolsillo: papeles, llaves, un celular.",
  [ParcelSize.MEDIUM]: "Cabe en el ba\xFAl de una moto: una caja de zapatos, un mercado peque\xF1o.",
  [ParcelSize.LARGE]: "No cabe en una moto: necesita carro y va con recargo."
};
var ParcelApproval = {
  /** Esperando que administración la mire. */
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  /**
   * Aprobada, pero la tarifa cambió demasiado antes de despacharla.
   *
   * Espera a que el cliente acepte el precio nuevo. Si no contesta a tiempo,
   * se cancela: cobrarle de más sin avisar sería peor que no llevarla.
   */
  AWAITING_REPRICE: "AWAITING_REPRICE"
};
var PARCEL_APPROVAL_LABELS = {
  [ParcelApproval.PENDING]: "Esperando aprobaci\xF3n",
  [ParcelApproval.APPROVED]: "Aprobada",
  [ParcelApproval.REJECTED]: "Rechazada",
  [ParcelApproval.AWAITING_REPRICE]: "Esperando que confirmes el precio"
};
var ParcelPayer = {
  /** Paga quien envía, en la recogida. */
  SENDER: "SENDER",
  /** Contraentrega: paga quien recibe. */
  RECIPIENT: "RECIPIENT"
};
var PARCEL_PAYER_LABELS = {
  [ParcelPayer.SENDER]: "Pago yo al entregar el paquete",
  [ParcelPayer.RECIPIENT]: "Paga quien lo recibe"
};
var RechargeStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED"
};
var WalletMovementType = {
  RECHARGE: "RECHARGE",
  DELIVERY_CUT: "DELIVERY_CUT",
  BONUS: "BONUS",
  ADJUSTMENT: "ADJUSTMENT"
};
var ListUnit = {
  UNIT: "UNIT",
  POUND: "POUND",
  KILO: "KILO",
  GRAM: "GRAM",
  DOZEN: "DOZEN",
  PACK: "PACK",
  LITER: "LITER"
};
var LIST_UNIT_LABELS = {
  UNIT: "unidad(es)",
  POUND: "libra(s)",
  KILO: "kilo(s)",
  GRAM: "gramo(s)",
  DOZEN: "docena(s)",
  PACK: "paquete(s)",
  LITER: "litro(s)"
};
var ListItemStatus = {
  /** El comercio todavía no lo mira. */
  PENDING: "PENDING",
  /** Hay: con su precio. */
  CONFIRMED: "CONFIRMED",
  /** No hay; puede traer un reemplazo sugerido. */
  UNAVAILABLE: "UNAVAILABLE"
};
var ListStage = {
  /** El comercio está poniendo disponibilidad y precios. */
  QUOTING: "QUOTING",
  /** Cotizada: el cliente decide reemplazos y confirma el total. */
  AWAITING_APPROVAL: "AWAITING_APPROVAL",
  /** El cliente confirmó: el pedido sigue su curso normal. */
  APPROVED: "APPROVED"
};

// src/order-status.ts
var ORDER_TRANSITIONS = {
  [OrderStatus.PENDING_PAYMENT]: [OrderStatus.PLACED, OrderStatus.CANCELLED],
  // Un domicilio no se programa: se pide y se prepara.
  [OrderStatus.SCHEDULED]: [],
  [OrderStatus.PLACED]: [OrderStatus.ACCEPTED, OrderStatus.REJECTED, OrderStatus.CANCELLED],
  [OrderStatus.ACCEPTED]: [OrderStatus.PREPARING, OrderStatus.CANCELLED],
  [OrderStatus.PREPARING]: [OrderStatus.READY_FOR_PICKUP, OrderStatus.CANCELLED],
  [OrderStatus.READY_FOR_PICKUP]: [OrderStatus.PICKED_UP, OrderStatus.CANCELLED],
  /**
   * Con el pedido ya en la calle la cancelación sigue siendo posible.
   *
   * No es un caso raro: si el cliente pagó por transferencia y el comprobante
   * no cuadra, el domiciliario decide en la puerta si cobra en efectivo o
   * cancela. Sin esta transición el pedido quedaba atrapado en `ON_THE_WAY`
   * para siempre, y el domiciliario con él, sin poder recibir otro.
   *
   * El cliente **no** puede usarla: `CUSTOMER_CANCELLABLE_STATUSES` lo limita
   * a antes de que el comercio acepte.
   */
  [OrderStatus.PICKED_UP]: [OrderStatus.ON_THE_WAY, OrderStatus.CANCELLED],
  [OrderStatus.ON_THE_WAY]: [OrderStatus.DELIVERED, OrderStatus.CANCELLED],
  [OrderStatus.DELIVERED]: [],
  [OrderStatus.CANCELLED]: [],
  [OrderStatus.REJECTED]: []
};
var TRANSITION_ACTORS = {
  [OrderStatus.PENDING_PAYMENT]: [UserRole.CUSTOMER],
  /** Programar es cosa del cliente; despachar, del sistema a su hora. */
  [OrderStatus.SCHEDULED]: [UserRole.CUSTOMER, UserRole.ADMIN],
  [OrderStatus.PLACED]: [UserRole.CUSTOMER, UserRole.ADMIN],
  [OrderStatus.ACCEPTED]: [UserRole.MERCHANT_OWNER, UserRole.MERCHANT_STAFF, UserRole.ADMIN],
  [OrderStatus.PREPARING]: [UserRole.MERCHANT_OWNER, UserRole.MERCHANT_STAFF, UserRole.ADMIN],
  [OrderStatus.READY_FOR_PICKUP]: [UserRole.MERCHANT_OWNER, UserRole.MERCHANT_STAFF, UserRole.ADMIN],
  [OrderStatus.PICKED_UP]: [UserRole.COURIER, UserRole.ADMIN],
  [OrderStatus.ON_THE_WAY]: [UserRole.COURIER, UserRole.ADMIN],
  [OrderStatus.DELIVERED]: [UserRole.COURIER, UserRole.ADMIN],
  /**
   * El domiciliario también cancela: es quien está en la puerta cuando un
   * pago no se puede verificar.
   */
  [OrderStatus.CANCELLED]: [
    UserRole.CUSTOMER,
    UserRole.MERCHANT_OWNER,
    UserRole.COURIER,
    UserRole.ADMIN
  ],
  [OrderStatus.REJECTED]: [UserRole.MERCHANT_OWNER, UserRole.MERCHANT_STAFF, UserRole.ADMIN]
};
var ACTIVE_ORDER_STATUSES = [
  OrderStatus.PLACED,
  OrderStatus.ACCEPTED,
  OrderStatus.PREPARING,
  OrderStatus.READY_FOR_PICKUP,
  OrderStatus.PICKED_UP,
  OrderStatus.ON_THE_WAY
];
var TERMINAL_ORDER_STATUSES = [
  OrderStatus.DELIVERED,
  OrderStatus.CANCELLED,
  OrderStatus.REJECTED
];
var CUSTOMER_CANCELLABLE_STATUSES = [
  OrderStatus.PENDING_PAYMENT,
  OrderStatus.PLACED
];
var PARCEL_TRANSITIONS = {
  [OrderStatus.PENDING_PAYMENT]: [OrderStatus.PLACED, OrderStatus.CANCELLED],
  /**
   * Programada: espera aprobación y hora.
   *
   * Solo sale hacia `PLACED` —cuando llega su momento y está aprobada— o hacia
   * `CANCELLED`, que cubre el rechazo de administración, el arrepentimiento
   * del cliente y el vencimiento sin respuesta.
   */
  [OrderStatus.SCHEDULED]: [OrderStatus.PLACED, OrderStatus.CANCELLED],
  [OrderStatus.PLACED]: [OrderStatus.PICKED_UP, OrderStatus.CANCELLED],
  [OrderStatus.PICKED_UP]: [OrderStatus.ON_THE_WAY, OrderStatus.CANCELLED],
  [OrderStatus.ON_THE_WAY]: [OrderStatus.DELIVERED, OrderStatus.CANCELLED],
  // Sin comercio, estos no llegan a existir.
  [OrderStatus.ACCEPTED]: [],
  [OrderStatus.PREPARING]: [],
  [OrderStatus.READY_FOR_PICKUP]: [],
  [OrderStatus.DELIVERED]: [],
  [OrderStatus.CANCELLED]: [],
  [OrderStatus.REJECTED]: []
};
function canTransition(from, to, type = OrderType.DELIVERY) {
  const tabla = type === OrderType.PARCEL ? PARCEL_TRANSITIONS : ORDER_TRANSITIONS;
  return tabla[from].includes(to);
}
function canRoleTransition(to, role) {
  return TRANSITION_ACTORS[to].includes(role);
}
function isActiveOrder(status) {
  return ACTIVE_ORDER_STATUSES.includes(status);
}
function isTerminalOrder(status) {
  return TERMINAL_ORDER_STATUSES.includes(status);
}
var ORDER_STATUS_LABELS = {
  [OrderStatus.PENDING_PAYMENT]: "Pendiente de pago",
  [OrderStatus.SCHEDULED]: "Programado",
  [OrderStatus.PLACED]: "Pedido realizado",
  [OrderStatus.ACCEPTED]: "Aceptado por el comercio",
  [OrderStatus.PREPARING]: "En preparaci\xF3n",
  [OrderStatus.READY_FOR_PICKUP]: "Listo para recoger",
  [OrderStatus.PICKED_UP]: "Recogido",
  [OrderStatus.ON_THE_WAY]: "En camino",
  [OrderStatus.DELIVERED]: "Entregado",
  [OrderStatus.CANCELLED]: "Cancelado",
  [OrderStatus.REJECTED]: "Rechazado"
};
var ORDER_STATUS_STEP = {
  [OrderStatus.PENDING_PAYMENT]: 0,
  [OrderStatus.SCHEDULED]: 0,
  [OrderStatus.PLACED]: 1,
  [OrderStatus.ACCEPTED]: 2,
  [OrderStatus.PREPARING]: 3,
  [OrderStatus.READY_FOR_PICKUP]: 4,
  [OrderStatus.PICKED_UP]: 5,
  [OrderStatus.ON_THE_WAY]: 5,
  [OrderStatus.DELIVERED]: 6,
  [OrderStatus.CANCELLED]: 0,
  [OrderStatus.REJECTED]: 0
};
var PARCEL_STATUS_STEP = {
  [OrderStatus.PENDING_PAYMENT]: 0,
  /**
   * Cero, no uno.
   *
   * Una encomienda programada todavía no ha empezado: pintar el primer paso
   * encendido diría que ya se está buscando domiciliario, y puede faltar una
   * semana. La pantalla enseña la fecha en su lugar.
   */
  [OrderStatus.SCHEDULED]: 0,
  [OrderStatus.PLACED]: 1,
  [OrderStatus.PICKED_UP]: 2,
  [OrderStatus.ON_THE_WAY]: 2,
  [OrderStatus.DELIVERED]: 3,
  [OrderStatus.ACCEPTED]: 0,
  [OrderStatus.PREPARING]: 0,
  [OrderStatus.READY_FOR_PICKUP]: 0,
  [OrderStatus.CANCELLED]: 0,
  [OrderStatus.REJECTED]: 0
};
var PARCEL_STATUS_LABELS = {
  [OrderStatus.SCHEDULED]: "Programada",
  [OrderStatus.PLACED]: "Buscando domiciliario",
  [OrderStatus.PICKED_UP]: "Paquete recogido",
  [OrderStatus.ON_THE_WAY]: "En camino al destino",
  [OrderStatus.DELIVERED]: "Entregado"
};
function orderStatusLabel(status, type) {
  if (type === OrderType.PARCEL) return PARCEL_STATUS_LABELS[status] ?? ORDER_STATUS_LABELS[status];
  return ORDER_STATUS_LABELS[status];
}

// src/constants.ts
var CITY = {
  name: "Medell\xEDn",
  department: "Antioquia",
  country: "CO",
  timezone: "America/Bogota",
  currency: "COP",
  /** Centro de referencia: Parque Berrío, La Candelaria. */
  center: { lat: 6.2518, lng: -75.5636 },
  /** Encuadre inicial del mapa (suroeste / noreste) cubriendo el Valle de Aburrá. */
  bounds: {
    southWest: { lat: 6.13, lng: -75.66 },
    northEast: { lat: 6.36, lng: -75.5 }
  },
  defaultZoom: 13
};
var MEDELLIN_LANDMARKS = {
  parqueBerrio: { lat: 6.2518, lng: -75.5636 },
  elPoblado: { lat: 6.2087, lng: -75.5674 },
  laureles: { lat: 6.2447, lng: -75.5916 },
  belen: { lat: 6.2295, lng: -75.6045 },
  robledo: { lat: 6.2775, lng: -75.5901 },
  envigado: { lat: 6.1667, lng: -75.5833 },
  itagui: { lat: 6.1719, lng: -75.5991 },
  bello: { lat: 6.3378, lng: -75.5544 },
  sabaneta: { lat: 6.1515, lng: -75.6166 }
};
var PAGINATION = {
  defaultLimit: 20,
  maxLimit: 100
};
var ASSIGNMENT = {
  /** Radio inicial de búsqueda alrededor del comercio. */
  radiusMeters: 5e3,
  /** Si nadie acepta, el radio se amplía hasta este máximo. */
  maxRadiusMeters: 12e3,
  /** Segundos que tiene el domiciliario para responder una oferta. */
  offerTimeoutSeconds: 30,
  /** Intentos con distintos domiciliarios antes de alertar al comercio y al admin. */
  maxAttempts: 6
};
var SPEED = {
  metersPerMinute: 400
};
function travelMinutes(meters) {
  return Math.max(1, Math.round(meters / SPEED.metersPerMinute));
}
var TRACKING = {
  /** Intervalo mínimo entre envíos de ubicación. */
  intervalSeconds: 8,
  /** O cada N metros recorridos, lo que ocurra primero. */
  distanceMeters: 25,
  /** Retención del histórico de ubicaciones. */
  retentionDays: 90,
  /** Cada cuánto se vacía el búfer de ubicaciones a la base de datos. */
  flushIntervalSeconds: 30
};
var MONEY = {
  currency: "COP",
  /** COP no usa decimales en la práctica; se guarda en centavos por precisión interna. */
  decimals: 0,
  factor: 100
};
var PLATFORM_DEFAULTS = {
  /** Porcentaje de comisión sobre el subtotal del comercio. */
  commissionRate: 10,
  /**
   * Día del mes en que vence el estado de cuenta anterior.
   *
   * Se cierra el mes y el comercio tiene los primeros días para pagar. Pasado
   * el vencimiento queda en mora y, si no paga, se le suspende.
   */
  billingDueDay: 5,
  /** Días antes del vencimiento en que se le avisa. */
  billingWarnDaysBefore: 2,
  /** Cuota mensual por defecto al pasar un comercio al plan fijo. */
  defaultMonthlyFee: 15e6,
  /** Tarifa de servicio cobrada al cliente: $1.500 */
  serviceFee: 15e4,
  /** Tarifa base de domicilio: $4.000 */
  baseDeliveryFee: 4e5,
  /** Adicional por kilómetro: $800 */
  perKmFee: 8e4,
  /** Mínimo de domicilio: $4.000 */
  minDeliveryFee: 4e5,
  /** Máximo de domicilio: $15.000 */
  maxDeliveryFee: 15e5,
  /** Pedido mínimo por defecto: $10.000 */
  minOrderAmount: 1e6,
  /** Propinas sugeridas: $0, $1.000, $2.000, $3.000 */
  tipPresets: [0, 1e5, 2e5, 3e5],
  /**
   * Lo que gana el domiciliario por entrega.
   *
   * Base fija más un adicional por kilómetro recorrido, y la propina íntegra.
   * Se paga sobre lo que la plataforma cobró de domicilio; la diferencia entre
   * ambos es lo que sostiene la operación.
   */
  courierBaseFee: 25e4,
  courierPerKmFee: 5e4,
  /**
   * Recargo de la encomienda según su tamaño, sobre la tarifa por distancia.
   *
   * El sobre no paga nada de más: es el mismo viaje que un domicilio. Lo
   * voluminoso sí, porque no cabe en una moto y hay que mandar un carro.
   */
  parcelDocumentFee: 0,
  parcelMediumFee: 1e5,
  parcelLargeFee: 4e5,
  /**
   * Clasificación: el cliente que más pide y el mensajero que más trabaja.
   *
   * El premium se gana al llegar al umbral de pedidos entregados en el mes y
   * se conserva el mes siguiente; da un descuento automático que asume la
   * plataforma, no el comercio. El bono del mensajero se paga en su
   * liquidación al llegar al umbral de entregas del período.
   */
  /**
   * El interruptor de la plataforma.
   *
   * Apagado, la tienda de clientes muestra el aviso y el servidor rechaza
   * pedidos nuevos. Existe para los días que no se trabaja y para cerrar por
   * horario sin tumbar nada: apagar es una decisión, no un despliegue.
   */
  platformOpen: true,
  platformClosedMessage: "En este momento no estamos prestando servicio. \xA1Volvemos pronto!",
  premiumOrdersPerMonth: 8,
  premiumDiscountPercent: 5,
  courierBonusDeliveries: 100,
  /**
   * Pedidos que un domiciliario puede llevar a la vez.
   *
   * Al llegar al tope deja de recibir ofertas hasta entregar alguno. Con
   * efectivo, cada pedido encima es plata que el domiciliario adelanta al
   * comercio: subir este número es una decisión de confianza, no de software.
   */
  maxActiveOrdersPerCourier: 5,
  /** Bono de recarga: $30.000. Se abona al saldo prepago del mensajero. */
  courierBonusAmount: 3e6,
  /**
   * Saldo prepago del domiciliario.
   *
   * El domiciliario cobra el domicilio en la calle y se lo queda; la
   * plataforma le descuenta de su saldo este porcentaje del domicilio (solo
   * del domicilio: ni el pedido ni la propina) en cada entrega. A cero, no
   * puede seguir en turno hasta recargar.
   */
  courierBalanceCutPercent: 20,
  /** Recargo por comercio no aliado: $2.000. Va para la plataforma. */
  nonPartnerFee: 2e5,
  /** Minutos antes de repicar por una lista sin revisar. */
  listReviewAlertMinutes: 10,
  /** Lo que ve el mensajero en Recargas: a dónde transferir. Lo escribe el admin. */
  rechargeAccountInfo: "",
  /** Reglas de las encomiendas programadas. */
  parcelScheduleMinHours: 3,
  parcelScheduleMaxDays: 30,
  parcelRepriceThresholdPercent: 15,
  parcelRepriceWindowMinutes: 30
};
function courierNetEarning(deliveryFee, tip, cutPercent) {
  const platformCut = Math.round(deliveryFee * cutPercent / 100);
  return { deliveryFee, platformCut, tip, total: deliveryFee - platformCut + tip };
}
function courierEarning(config, distanceMeters, tip) {
  const distanceBonus = Math.round(distanceMeters / 1e3 * config.courierPerKmFee);
  return {
    baseAmount: config.courierBaseFee,
    distanceBonus,
    tip,
    total: config.courierBaseFee + distanceBonus + tip
  };
}
var UPLOAD = {
  maxImageBytes: 5 * 1024 * 1024,
  allowedImageTypes: ["image/jpeg", "image/png", "image/webp"],
  maxDocumentBytes: 10 * 1024 * 1024,
  /**
   * Video de los anuncios.
   *
   * Veinte megas y treinta segundos. No es una cifra bonita: es lo que aguanta
   * un cliente con datos móviles antes de cerrar la aplicación, y lo que dura
   * un anuncio antes de que nadie lo vea entero. Un video más largo tampoco se
   * ve completo, así que solo gasta plan de datos.
   */
  maxVideoBytes: 20 * 1024 * 1024,
  maxVideoSeconds: 30,
  allowedVideoTypes: ["video/mp4", "video/webm"],
  /** El GIF va aparte: es imagen, pero no se puede convertir a WebP estático. */
  allowedAnimatedTypes: ["image/gif"]
};
var STORY_TTL_HOURS = 24;
var AUTH = {
  accessTokenTtl: "24h",
  refreshTokenTtlDays: 30,
  maxLoginAttempts: 5,
  lockoutMinutes: 15,
  minPasswordLength: 8
};
var WS_NAMESPACE = {
  CUSTOMER: "/customer",
  MERCHANT: "/merchant",
  COURIER: "/courier"
};
var WS_HEARTBEAT = {
  pingIntervalMs: 5e3,
  pingTimeoutMs: 5e3
};
var QUEUE = {
  ASSIGNMENT: "assignment",
  NOTIFICATIONS: "notifications",
  PAYMENTS: "payments",
  SETTLEMENTS: "settlements",
  LOCATION_FLUSH: "location-flush",
  REPORTS: "reports",
  /** Despacho de encomiendas programadas a su hora. */
  PARCELS: "parcels",
  /** Alertas de listas sin revisar a tiempo. */
  LISTS: "lists"
};

// src/permisos.ts
var ACCIONES_ADMIN = {
  ver: "Ver",
  crear: "Crear",
  editar: "Editar",
  eliminar: "Eliminar",
  bloquear: "Bloquear y activar",
  intervenir: "Intervenir pedidos",
  verificar: "Verificar",
  responder: "Responder",
  resolver: "Resolver",
  decidir: "Aprobar y despachar",
  gestionar: "Registrar pagos y planes",
  saldo: "Aprobar recargas y ajustar saldo",
  avisar: "Enviar avisos a la app",
  cerrar: "Cerrar per\xEDodos y pagar"
};
var MODULOS_ADMIN = [
  {
    key: "operacion",
    label: "Operaci\xF3n y pedidos",
    descripcion: "Monitor en vivo; intervenir es reasignar, cancelar o mover pedidos.",
    acciones: ["ver", "intervenir"]
  },
  {
    key: "programadas",
    label: "Encomiendas programadas",
    descripcion: "Las que esperan aprobaci\xF3n o despacho.",
    acciones: ["ver", "decidir"]
  },
  {
    key: "manuales",
    label: "Asignaci\xF3n manual",
    descripcion: "Lotes de env\xEDos de comercios y pedidos a comercios no aliados.",
    acciones: ["ver", "gestionar"]
  },
  {
    key: "comercios",
    label: "Comercios",
    descripcion: "Editar incluye su men\xFA, horarios y usuarios; bloquear cambia su estado.",
    acciones: ["ver", "crear", "editar", "bloquear"]
  },
  {
    key: "domiciliarios",
    label: "Domiciliarios y flota",
    descripcion: "Editar incluye sus cuentas de cobro; saldo es revisar recargas y corregir el saldo.",
    acciones: ["ver", "crear", "verificar", "editar", "saldo", "avisar"]
  },
  {
    key: "usuarios",
    label: "Usuarios de la plataforma",
    descripcion: "Clientes y dem\xE1s cuentas; editar es restablecer su contrase\xF1a.",
    acciones: ["ver", "bloquear", "editar"]
  },
  {
    key: "zonas",
    label: "Zonas y tarifas",
    descripcion: "Cobertura y lo que cuesta el domicilio en cada una.",
    acciones: ["ver", "crear", "editar", "eliminar"]
  },
  {
    key: "cupones",
    label: "Cupones",
    descripcion: "Descuentos de la plataforma.",
    acciones: ["ver", "crear", "editar", "eliminar"]
  },
  {
    key: "anuncios",
    label: "Publicidad",
    descripcion: "Anuncios y destacados de la tienda.",
    acciones: ["ver", "crear", "editar", "eliminar"]
  },
  {
    key: "soporte",
    label: "Chat de soporte",
    descripcion: "Conversaciones con los clientes.",
    acciones: ["ver", "responder"]
  },
  {
    key: "reclamos",
    label: "Reclamos",
    descripcion: "Quejas por pedidos y su resoluci\xF3n.",
    acciones: ["ver", "resolver"]
  },
  {
    key: "cobros",
    label: "Cobros a comercios",
    descripcion: "Comisiones, mensualidades, pagos y suspensi\xF3n por mora.",
    acciones: ["ver", "gestionar"]
  },
  {
    key: "liquidaciones",
    label: "Liquidaciones",
    descripcion: "Per\xEDodos de pago a domiciliarios y comercios.",
    acciones: ["ver", "cerrar"]
  },
  {
    key: "informes",
    label: "Informes y calificaciones",
    descripcion: "Informes de la plataforma, Excel y peores calificaciones.",
    acciones: ["ver"]
  },
  {
    key: "clasificacion",
    label: "Clasificaci\xF3n",
    descripcion: "Rankings de clientes premium y mensajeros con bono.",
    acciones: ["ver"]
  },
  {
    key: "ajustes",
    label: "Ajustes y categor\xEDas",
    descripcion: "Par\xE1metros de la plataforma y categor\xEDas de la tienda.",
    acciones: ["ver", "editar"]
  },
  {
    key: "auditoria",
    label: "Bit\xE1cora de auditor\xEDa",
    descripcion: "Qui\xE9n hizo qu\xE9 y cu\xE1ndo.",
    acciones: ["ver"]
  }
];
function tienePermiso(permisos, modulo, accion) {
  if (permisos == null) return true;
  return permisos[modulo]?.includes(accion) ?? false;
}
function esAccesoTotal(permisos) {
  return permisos == null;
}

// src/events.ts
var WS_EVENT = {
  // Servidor → cliente
  ORDER_CREATED: "order.created",
  ORDER_STATUS_CHANGED: "order.status_changed",
  ORDER_CANCELLED: "order.cancelled",
  ORDER_ETA_UPDATED: "order.eta_updated",
  COURIER_ASSIGNED: "courier.assigned",
  COURIER_LOCATION: "courier.location",
  COURIER_ARRIVED: "courier.arrived",
  ASSIGNMENT_OFFERED: "assignment.offered",
  ASSIGNMENT_EXPIRED: "assignment.expired",
  /** La oferta se retiró: otro la tomó o el pedido se canceló. */
  ASSIGNMENT_CANCELLED: "assignment.cancelled",
  /** Nadie aceptó tras agotar los intentos; alerta al comercio y al admin. */
  ASSIGNMENT_FAILED: "assignment.failed",
  /** El cliente subió el comprobante de su transferencia. */
  RECEIPT_UPLOADED: "payment.receipt_uploaded",
  /** El domiciliario ya revisó el comprobante: aprobado o rechazado. */
  PAYMENT_RESOLVED: "payment.resolved",
  /** Mensaje del chat entre cliente y domiciliario. */
  ORDER_MESSAGE: "order.message",
  /** Mensaje del chat de soporte. */
  SUPPORT_MESSAGE: "support.message",
  NOTIFICATION: "notification",
  /** Al domiciliario: su saldo cambió (recarga aprobada, descuento, bono, ajuste). */
  WALLET_UPDATED: "wallet.updated",
  /** La lista de un pedido cambió (precio, disponibilidad, decisión del cliente). */
  LIST_UPDATED: "list.updated",
  /** A todos los domiciliarios: la lista de pedidos sin tomar cambió. */
  PENDING_ORDERS_UPDATED: "assignment.pending_updated",
  // Cliente → servidor
  LOCATION_UPDATE: "location.update",
  SUBSCRIBE_ORDER: "subscribe.order",
  UNSUBSCRIBE_ORDER: "unsubscribe.order"
};
var WS_ROOM = {
  order: (orderId) => `order:${orderId}`,
  user: (userId) => `user:${userId}`,
  merchant: (merchantId) => `merchant:${merchantId}`,
  courier: (courierId) => `courier:${courierId}`,
  /** Sala del monitor de operación: solo administradores. */
  admin: () => "admin"
};

export { ACCIONES_ADMIN, ACCOUNT_KIND_LABELS, ACCOUNT_TYPE_LABELS, ACTIVE_ORDER_STATUSES, ACTIVE_PAYMENT_METHODS, ASSIGNMENT, AUTH, AccountType, AssignmentStatus, BILLING_PLAN_LABELS, BankAccountKind, BillingPlan, CITY, COMPLAINT_REASON_LABELS, COMPLAINT_STATUS_LABELS, CUSTOMER_CANCELLABLE_STATUSES, ComplaintReason, ComplaintStatus, CourierStatus, DiscountType, LIST_UNIT_LABELS, ListItemStatus, ListStage, ListUnit, MEDELLIN_LANDMARKS, MODULOS_ADMIN, MONEY, MerchantStatus, MerchantUserRole, NotificationType, ORDER_STATUS_LABELS, ORDER_STATUS_STEP, ORDER_TRANSITIONS, OrderStatus, OrderType, PAGINATION, PARCEL_APPROVAL_LABELS, PARCEL_PAYER_LABELS, PARCEL_SIZE_HINTS, PARCEL_SIZE_LABELS, PARCEL_STATUS_LABELS, PARCEL_STATUS_STEP, PARCEL_TRANSITIONS, PAYMENT_METHOD_LABELS, PLATFORM_DEFAULTS, PORTAL_ROLES, ParcelApproval, ParcelPayer, ParcelSize, PaymentMethod, PaymentStatus, Portal, QUEUE, ReceiptStatus, RechargeStatus, SPEED, STORY_TTL_HOURS, SettlementStatus, StoryMedia, SupportStatus, TERMINAL_ORDER_STATUSES, TRACKING, TRANSITION_ACTORS, UPLOAD, UserRole, UserStatus, VEHICLE_LABELS, VehicleType, WS_EVENT, WS_HEARTBEAT, WS_NAMESPACE, WS_ROOM, WalletMovementType, canLoginToPortal, canRoleTransition, canTransition, courierEarning, courierNetEarning, esAccesoTotal, esBilletera, isActiveOrder, isTerminalOrder, orderStatusLabel, tienePermiso, travelMinutes };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map